import { useRecoilValue } from 'recoil'

import { EditMessage } from './EditMessage'
import { SelectTemplate } from './templateSelection/SelectTemplate'

import { pageState } from 'Pages/Campaign/recoil/state/page'

export const Step2 = () => {
  const { step2SelectTemplate } = useRecoilValue(pageState)

  return (
    <>
      {step2SelectTemplate && <SelectTemplate />}
      {!step2SelectTemplate && <EditMessage />}
    </>
  )
}
